import * as React from 'react';
import { getLogo } from '../../helpers/logo';
import styles from './styles.module.scss';

const Loader = () => {
  return (
    <div className={styles.loader}>
      <img src={getLogo()} className={styles.logo} alt="logo" />
    </div>
  );
};

export default Loader;
